import {useRouteLoaderData} from '@remix-run/react'

import {Disclosure, DisclosureButton, DisclosurePanel, Transition} from '@headlessui/react'
import {getTranslation} from '~/localization/translation'
import type {RootLoaderResponse} from '~/types/index.js'

import {FaqIconChevronUp} from '~/icons/faq/brg-icon-faq-chevron-up'
import {getDomainConfig} from '~/domains'

export default function FAQPage() {
  const {language, domain, locale} = useRouteLoaderData('root') as RootLoaderResponse
  const {camelCaseUrl, siteName} = getDomainConfig(domain, locale)
  const translations = getTranslation(language)

  return (
    <div className="mx-auto flex flex-col items-center pb-[260px] pt-12">
      <h1 className="mb-8 mr-2 text-left text-2xl font-medium text-[#030303] mobile:text-base">
        {translations.FAQ.title}
      </h1>
      <section className="w-[940px] space-y-6 tablet:w-full tablet:px-4">
        <Disclosure as="div" className="w-full rounded-xl border-2 border-[#030303] p-5 mobile:px-4 mobile:py-2">
          {({open}) => (
            <>
              <DisclosureButton
                className={
                  open
                    ? 'flex w-full items-center justify-between mobile:h-16 mobile:py-2'
                    : 'flex w-full items-center justify-between mobile:h-16'
                }
              >
                <h2 className="w-fit text-left text-2xl leading-7 mobile:w-9/12 mobile:text-base">
                  {translations.FAQ.question1}
                </h2>
                <div
                  className={
                    open
                      ? 'flex h-[50px] w-[50px] items-center justify-center self-center rounded-full border-2 border-[#ffffff] bg-[#030303] transition duration-300 ease-in-out mobile:h-8 mobile:w-8 mobile:selection:ml-[15px]'
                      : 'flex h-[50px] w-[50px] items-center justify-center self-center rounded-full border-2 border-[#030303] bg-[#ffffff] shadow-faqButton transition duration-300 ease-in-out mobile:h-8 mobile:w-8 mobile:selection:ml-[15px]'
                  }
                >
                  <FaqIconChevronUp
                    strokeWidth="2"
                    className={
                      open
                        ? 'transition-transform duration-300 ease-in-out'
                        : 'rotate-180 transform transition-transform duration-300 ease-in-out'
                    }
                    fill={open ? '#ffffff' : '#030303'}
                  />
                </div>
              </DisclosureButton>
              <Transition
                show={open}
                enter="transition ease-out duration-300"
                enterFrom="transform opacity-0 -translate-y-2"
                enterTo="transform opacity-100 translate-y-0"
                leave="transition ease-in duration-200"
                leaveFrom="transform opacity-100 translate-y-0"
                leaveTo="transform opacity-0 -translate-y-2"
              >
                <DisclosurePanel className="w-[full] transition-all duration-300 ease-in-out">
                  <p className="text-left text-[18px] text-[#6F6C90] mobile:text-base mobile:text-[#4f4f4f]">
                    {translations.FAQ.answer1(camelCaseUrl)}
                  </p>
                </DisclosurePanel>
              </Transition>
            </>
          )}
        </Disclosure>

        <Disclosure as="div" className="w-full rounded-xl border-2 border-[#030303] p-5 mobile:px-4 mobile:py-2">
          {({open}) => (
            <>
              <DisclosureButton
                className={
                  open
                    ? 'flex w-full items-center justify-between mobile:h-16 mobile:py-2'
                    : 'flex w-full items-center justify-between mobile:h-16'
                }
              >
                <h2 className="w-fit text-left text-2xl leading-7 mobile:w-9/12 mobile:text-base">
                  {translations.FAQ.question2}
                </h2>
                <div
                  className={
                    open
                      ? 'flex h-[50px] w-[50px] items-center justify-center self-center rounded-full border-2 border-[#ffffff] bg-[#030303] transition duration-300 ease-in-out mobile:h-8 mobile:w-8 mobile:selection:ml-[15px]'
                      : 'flex h-[50px] w-[50px] items-center justify-center self-center rounded-full border-2 border-[#030303] bg-[#ffffff] shadow-faqButton transition duration-300 ease-in-out mobile:h-8 mobile:w-8 mobile:selection:ml-[15px]'
                  }
                >
                  <FaqIconChevronUp
                    strokeWidth="2"
                    className={
                      open
                        ? 'transition-transform duration-300 ease-in-out'
                        : 'rotate-180 transform transition-transform duration-300 ease-in-out'
                    }
                    fill={open ? '#ffffff' : '#030303'}
                  />
                </div>
              </DisclosureButton>
              <Transition
                show={open}
                enter="transition ease-out duration-300"
                enterFrom="transform opacity-0 -translate-y-2"
                enterTo="transform opacity-100 translate-y-0"
                leave="transition ease-in duration-200"
                leaveFrom="transform opacity-100 translate-y-0"
                leaveTo="transform opacity-0 -translate-y-2"
              >
                <DisclosurePanel className="w-full transition-all duration-300 ease-in-out">
                  <p className="text-left text-[18px] text-[#6F6C90] mobile:text-base mobile:text-[#4f4f4f]">
                    {translations.FAQ.answer2}
                  </p>
                </DisclosurePanel>
              </Transition>
            </>
          )}
        </Disclosure>

        <Disclosure as="div" className="w-full rounded-xl border-2 border-[#030303] p-5 mobile:px-4 mobile:py-2">
          {({open}) => (
            <>
              <DisclosureButton
                className={
                  open
                    ? 'flex w-full items-center justify-between mobile:h-16 mobile:py-2'
                    : 'flex w-full items-center justify-between mobile:h-16'
                }
              >
                <h2 className="w-fit text-left text-2xl leading-7 mobile:w-9/12 mobile:text-base">
                  {translations.FAQ.question3}
                </h2>
                <div
                  className={
                    open
                      ? 'flex h-[50px] w-[50px] items-center justify-center self-center rounded-full border-2 border-[#ffffff] bg-[#030303] transition duration-300 ease-in-out mobile:h-8 mobile:w-8 mobile:selection:ml-[15px]'
                      : 'flex h-[50px] w-[50px] items-center justify-center self-center rounded-full border-2 border-[#030303] bg-[#ffffff] shadow-faqButton transition duration-300 ease-in-out mobile:h-8 mobile:w-8 mobile:selection:ml-[15px]'
                  }
                >
                  <FaqIconChevronUp
                    strokeWidth="2"
                    className={`transition-transform duration-300 ease-in-out ${open ? '' : 'rotate-180 transform'}`}
                    fill={open ? '#ffffff' : '#030303'}
                  />
                </div>
              </DisclosureButton>
              <Transition
                show={open}
                enter="transition ease-out duration-300"
                enterFrom="transform opacity-0 -translate-y-2"
                enterTo="transform opacity-100 translate-y-0"
                leave="transition ease-in duration-200"
                leaveFrom="transform opacity-100 translate-y-0"
                leaveTo="transform opacity-0 -translate-y-2"
              >
                <DisclosurePanel className="w-full transition-all duration-300 ease-in-out">
                  <p className="text-left text-[18px] text-[#6F6C90] mobile:text-base mobile:text-[#4f4f4f]">
                    {translations.FAQ.answer3(camelCaseUrl)}
                  </p>
                </DisclosurePanel>
              </Transition>
            </>
          )}
        </Disclosure>

        <Disclosure as="div" className="w-full rounded-xl border-2 border-[#030303] p-5 mobile:px-4 mobile:py-2">
          {({open}) => (
            <>
              <DisclosureButton
                className={
                  open
                    ? 'flex w-full items-center justify-between mobile:h-16 mobile:py-2'
                    : 'flex w-full items-center justify-between mobile:h-16'
                }
              >
                <h2 className="w-fit text-left text-2xl leading-7 mobile:w-9/12 mobile:text-base">
                  {translations.FAQ.question4}
                </h2>
                <div
                  className={
                    open
                      ? 'flex h-[50px] w-[50px] items-center justify-center self-center rounded-full border-2 border-[#ffffff] bg-[#030303] transition duration-300 ease-in-out mobile:h-8 mobile:w-8 mobile:selection:ml-[15px]'
                      : 'flex h-[50px] w-[50px] items-center justify-center self-center rounded-full border-2 border-[#030303] bg-[#ffffff] shadow-faqButton transition duration-300 ease-in-out mobile:h-8 mobile:w-8 mobile:selection:ml-[15px]'
                  }
                >
                  <FaqIconChevronUp
                    strokeWidth="2"
                    className={
                      open
                        ? 'transition-transform duration-300 ease-in-out'
                        : 'rotate-180 transform transition-transform duration-300 ease-in-out'
                    }
                    fill={open ? '#ffffff' : '#030303'}
                  />
                </div>
              </DisclosureButton>
              <Transition
                show={open}
                enter="transition ease-out duration-300"
                enterFrom="transform opacity-0 -translate-y-2"
                enterTo="transform opacity-100 translate-y-0"
                leave="transition ease-in duration-200"
                leaveFrom="transform opacity-100 translate-y-0"
                leaveTo="transform opacity-0 -translate-y-2"
              >
                <DisclosurePanel className="w-full transition-all duration-300 ease-in-out">
                  <p className="text-left text-[18px] text-[#6F6C90] mobile:text-base mobile:text-[#4f4f4f]">
                    {translations.FAQ.answer4(siteName)}
                  </p>
                </DisclosurePanel>
              </Transition>
            </>
          )}
        </Disclosure>

        <Disclosure as="div" className="w-full rounded-xl border-2 border-[#030303] p-5 mobile:px-4 mobile:py-2">
          {({open}) => (
            <>
              <DisclosureButton
                className={
                  open
                    ? 'flex w-full items-center justify-between mobile:h-16 mobile:py-2'
                    : 'flex w-full items-center justify-between mobile:h-16'
                }
              >
                <h2 className="w-fit text-left text-2xl leading-7 mobile:w-9/12 mobile:text-base">
                  {translations.FAQ.question5}
                </h2>
                <div
                  className={
                    open
                      ? 'flex h-[50px] w-[50px] items-center justify-center self-center rounded-full border-2 border-[#ffffff] bg-[#030303] transition duration-300 ease-in-out mobile:h-8 mobile:w-8 mobile:selection:ml-[15px]'
                      : 'flex h-[50px] w-[50px] items-center justify-center self-center rounded-full border-2 border-[#030303] bg-[#ffffff] shadow-faqButton transition duration-300 ease-in-out mobile:h-8 mobile:w-8 mobile:selection:ml-[15px]'
                  }
                >
                  <FaqIconChevronUp
                    strokeWidth="2"
                    className={
                      open
                        ? 'transition-transform duration-300 ease-in-out'
                        : 'rotate-180 transform transition-transform duration-300 ease-in-out'
                    }
                    fill={open ? '#ffffff' : '#030303'}
                  />
                </div>
              </DisclosureButton>
              <Transition
                show={open}
                enter="transition ease-out duration-300"
                enterFrom="transform opacity-0 -translate-y-2"
                enterTo="transform opacity-100 translate-y-0"
                leave="transition ease-in duration-200"
                leaveFrom="transform opacity-100 translate-y-0"
                leaveTo="transform opacity-0 -translate-y-2"
              >
                <DisclosurePanel className="w-full transition-all duration-300 ease-in-out">
                  <p className="text-left text-[18px] text-[#6F6C90] mobile:text-base mobile:text-[#4f4f4f]">
                    {translations.FAQ.answer5(siteName)}
                  </p>
                </DisclosurePanel>
              </Transition>
            </>
          )}
        </Disclosure>

        <Disclosure as="div" className="w-full rounded-xl border-2 border-[#030303] p-5 mobile:px-4 mobile:py-2">
          {({open}) => (
            <>
              <DisclosureButton
                className={
                  open
                    ? 'flex w-full items-center justify-between mobile:h-16 mobile:py-2'
                    : 'flex w-full items-center justify-between mobile:h-16'
                }
              >
                <h2 className="w-fit text-left text-2xl leading-7 mobile:w-9/12 mobile:text-base">
                  {translations.FAQ.question6}
                </h2>
                <div
                  className={
                    open
                      ? 'flex h-[50px] w-[50px] items-center justify-center self-center rounded-full border-2 border-[#ffffff] bg-[#030303] transition duration-300 ease-in-out mobile:h-8 mobile:w-8 mobile:selection:ml-[15px]'
                      : 'flex h-[50px] w-[50px] items-center justify-center self-center rounded-full border-2 border-[#030303] bg-[#ffffff] shadow-faqButton transition duration-300 ease-in-out mobile:h-8 mobile:w-8 mobile:selection:ml-[15px]'
                  }
                >
                  <FaqIconChevronUp
                    strokeWidth="2"
                    className={
                      open
                        ? 'transition-transform duration-300 ease-in-out'
                        : 'rotate-180 transform transition-transform duration-300 ease-in-out'
                    }
                    fill={open ? '#ffffff' : '#030303'}
                  />
                </div>
              </DisclosureButton>
              <Transition
                show={open}
                enter="transition ease-out duration-300"
                enterFrom="transform opacity-0 -translate-y-2"
                enterTo="transform opacity-100 translate-y-0"
                leave="transition ease-in duration-200"
                leaveFrom="transform opacity-100 translate-y-0"
                leaveTo="transform opacity-0 -translate-y-2"
              >
                <DisclosurePanel className="w-full transition-all duration-300 ease-in-out">
                  <p className="text-left text-[18px] text-[#6F6C90] mobile:text-base mobile:text-[#4f4f4f]">
                    {translations.FAQ.answer6}
                  </p>
                </DisclosurePanel>
              </Transition>
            </>
          )}
        </Disclosure>
      </section>
    </div>
  )
}
